/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {sendSparkPayment} from '../api'

export const useMutationSendSparkPayment = createReactQueryMutationHook('sendSparkPayment', sendSparkPayment)
